import styled from 'styled-components';

export const StyledLoadingIndicator = styled.div`
  position: relative;
  width: 100%;
  min-height: ${({ size }) => size ?? '30'}px;
  display: flex;
  justify-content: center;
  align-items: center;

  .atom-loading {
    &__ring {
      position: absolute;
      top: calc(50% - ${({ size }) => size ?? '30'}px / 2);
      left: calc(50% - ${({ size }) => size ?? '30'}px / 2);
      width: ${({ size }) => size ?? '30'}px;
      height: ${({ size }) => size ?? '30'}px;

      &:first-child {
        transform: skew(30deg, 20deg);
      }

      &:last-child {
        transform: skew(-30deg, -20deg) scale(-1, 1);

        svg {
          animation-delay: -0.75s;
        }
      }
    }
  }
`;
